export default "__VITE_ASSET__u3p_BVvo__"